import { createFeatureSelector, createSelector } from '@ngrx/store';

import { State } from './admin-users.state';

export const getAdminUsersState = createFeatureSelector<State>('adminUsers');

export const selectUsers = createSelector(
  getAdminUsersState,
  state => state.users,
);

export const selectLoading = createSelector(
  getAdminUsersState,
  state => state.loading,
);

export const selectError = createSelector(
  getAdminUsersState,
  state => state.error,
);

// API Key selectors (SEOMS-349)
export const selectApiKeys = createSelector(
  getAdminUsersState,
  state => state.apiKeys,
);

export const selectApiKeysLoading = createSelector(
  getAdminUsersState,
  state => state.apiKeysLoading,
);

export const selectApiKeysError = createSelector(
  getAdminUsersState,
  state => state.apiKeysError,
);

export const selectCreatedApiKey = createSelector(
  getAdminUsersState,
  state => state.createdApiKey,
);

// User token selectors (SEOMS-349 inline expand)
export const selectExpandedUserId = createSelector(
  getAdminUsersState,
  state => state.expandedUserId,
);

export const selectUserTokens = createSelector(
  getAdminUsersState,
  state => state.userTokens,
);

export const selectUserTokensLoading = createSelector(
  getAdminUsersState,
  state => state.userTokensLoading,
);

export const selectUserTokensError = createSelector(
  getAdminUsersState,
  state => state.userTokensError,
);
